import React from "react";
import "../style.css"; // Ensure this path matches your CSS file

const Footer = () => {
  return (
    <footer>
      <p>&copy; 2025 QuickFit. All rights reserved.</p>
      <div className="social-icons">
        <a href="#">Facebook</a> | <a href="https://www.instagram.com" target="_blank" rel="noopener noreferrer">Instagram</a> | <a href="#">TikTok</a>
      </div>
    </footer>
  );
};

export default Footer;
